<div
  class="grid grid-cols-1 md:grid-cols-{{
    columns?.length
  }} gap-8 px-5 md:px-10 lg:px-40 py-10 lg:py-28"
>
  <app-block-list [blockIdList]="columns"></app-block-list>
</div>
